import PulseApiService from './pulseApiService'

export default PulseApiService
